import useTableRequest from "../../../hooks/useTableRequest";
import { useEffect, useState } from "react";
import Table from "../../../components/common/table/Table";
import Title from "../../../components/common/title/Title";
import { customerSalesReportsColumns } from "../../../constant/tables-columns/tablesColums";
import { digitsThree } from "../../../utils/price";
import UserReportsFilter from "./CustomerSalesReportsFilter";
import ExportExcel from "../../../components/common/export-exel/ExportExel";

export default function CustomerSalesReports() {
  const tableRequest = useTableRequest({ initialLoading: true });
  const [userReportsData, setUsersReportsData] = useState([]);

  const getProductReports = async (params) => {
    const path = "admin/reports/ordersGroupedByMobile";
    return tableRequest.load({ path, params: { ...params } }, (response) => {
      setUsersReportsData(response?.data?.result);
    });
  };

  useEffect(() => {
    getProductReports({});
  }, []);

  const [filter, setFilter] = useState();

  const filterDataHandler = (newParams) => {
    setFilter({ ...filter, ...newParams });
    const allFilter = {
      ...filter,
      ...newParams,
    };
    getProductReports(allFilter);
  };

  const data = [];

  userReportsData?.map((item) =>
    data.push({
      ordersTotalCount: digitsThree(item.ordersTotalCount),
      finalPriceWithoutShippingSum: digitsThree(
        item.finalPriceWithoutShippingSum
      ),
      totalProductsPriceSum: digitsThree(item.totalProductsPriceSum),
      name: item?.name,
      mobile: item?.mobile,
    })
  );

  const exportReportsData = [];

  userReportsData?.map((item) =>
    exportReportsData.push({
      نام: item?.name,
      موبایل: item?.mobile,
      "مجموع تعداد سفارش": item?.ordersTotalCount,
      "مجموع ناخالص": item?.totalProductsPriceSum,
      "مجموع خالص": item?.finalPriceWithoutShippingSum,
    })
  );

  return (
    <div className="bg-white dark:bg-gray-900 rounded-3xl p-6">
      <div className="flex flex-col sm:flex-row justify-betwseen items-center">
        <Title title={"گزارش خرید مشتری ها"} />
        <div className="w-full mt-4 sm:mt-0 flex justify-end">
          <ExportExcel disabled={tableRequest.status !== "success"} jsonData={exportReportsData} />
        </div>
      </div>
      <p className="mt-3 text-sm text-slate-600 dark:text-slate-300">سفارش‌ها را بر اساس شماره موبایل مشتری جمع می‌کند و تعداد سفارش و فروش خالص و ناخالص را در بازهٔ تاریخ پرداخت نشان می‌دهد.</p>
      <UserReportsFilter filterDataHandler={filterDataHandler} />
      <Table loading={tableRequest.loading} error={tableRequest.error} idle={tableRequest.status === "idle"} onRetry={tableRequest.retry} columns={customerSalesReportsColumns} rows={data} />
    </div>
  );
}
